<template>
    <div class="profile_content" ref="screen4">
        <div class="profile_wrap">
            <el-row  style="width:100%"  type="flex" align="middle"  class="hidden-xs-only">
                <el-col :md="11" :sm="24">
                    <div class="grid-content bg-purple left" style="height:100%;">
                        <!-- <div>
                            <div class="label company_label" style="padding: 6px 0; border-radius:2px; margin-bottom:34px">关于云上采</div>
                            <div style="color:#A81F27;" class="marginB22 company_name">云上采大数据发展有限公司</div>
                            <div class="marginB22 info">
                                云上采大数据发展有限公司是一家服务于政企采购全过程咨询提供信息化服务的公司，注册资本5223万元，主要从事政府采购领域内的系统开发、云计算数据开发、政府采购全过程信息咨询平台服务、网络信息技术服务，以及旅游开发，民宿产业生态服务。
                            </div>
                            <el-row :gutter="5">
                                <el-col :span="4.3">
                                    <router-link to="/production/contact#section"><div class="grid-content bg-purple label" style="padding: 2px 10px;"> 荣誉证书</div></router-link>
                                </el-col>
                            </el-row>     
                        </div> -->
                        <el-row :gutter="60">
                            <el-col  
                                v-for="(item, index) in dataList"
                                :key="index" 
                                :md="12" 
                                :sm="12"
                                :xs="24">
                                <div class="company_label">{{item}}</div>
                            </el-col>
                        </el-row> 
                    </div>
                </el-col>
                <el-col :md="13" :sm="24">
                    <div class="right">
                        <!-- <el-image :src="src"></el-image> -->

                        <!-- <el-image 
                            style="width: 100%; height: 100% ;overflow: revert;"
                            :src="src">
                        </el-image> -->
                        <div class="swiper-container">
                            <swiper :options="swiperOption" ref="mySwiper1" v-if="companySwiper.length > 0">
                                <swiper-slide v-for="(item, index) in companySwiper" :key="index">
                                    <img @click="handleInfo(item.ID)" :src="item.url" class="swiper_img" alt="" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div>    
                    </div>
                </el-col>
            </el-row>  
            <el-row class="hidden-sm-and-up">
                <el-col :md="12" :sm="24">
                    <div class="grid-content bg-purple left" style="height:100%">
                        <el-row :gutter="40">
                            <el-col  
                                v-for="(item, index) in dataList"
                                :key="index" 
                                :span="12">
                                <div class="company_label">{{item}}</div>
                            </el-col>
                        </el-row> 
                    </div>
                </el-col>
                <el-col :span="24" type="flex" align="middle">
                    <div class="right">
                        <div class="swiper-container">
                            <swiper :options="swiperOption" ref="mySwiper1" v-if="companySwiper.length > 0">
                                <swiper-slide v-for="(item, index) in companySwiper" :key="index">
                                    <img @click="handleInfo(item.ID)" :src="item.url" class="swiper_img" alt="" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div> 
                    </div>
                </el-col>
            </el-row>  
        </div>
    </div>    
</template>

<script>
export default {
  data() {
    return {
        src: require('@/assets/img/companyInfo.png'),
        companySwiper:[
            {
                url: require('@/assets/img/demo/bg3.jpg')
            }
        ],
        swiperOption: {
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed:500,
            autoHeight: true, // 自适应高度
            spaceBetween: 30,
            effect: 'fade',
            loop:true,//必须
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },  
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        },
        dataList: ['系统运营','软件开发','网页设计','培训服务','采购咨询','特产自营'],
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
    handleNavigate(){
      this.$router.push('/production/1').catch((v) => {})
    }
  },
}
</script>  

<style lang="scss" scoped>
.profile_content{
    .profile_footer{
        display: flex;
        // justify-content: center;
        padding: 0 20%;
        box-sizing: border-box;
        align-items: center;
        background: #A81F27;
        height: 80px;
        width: 100%;
    }
    .profile_wrap {
        // width: 70%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: calc(100vh - 70px);
        @media screen and (max-width: 768px) {
            height: auto !important;
        }
        .left{
            height: 100% !important;
            padding: 20px 0;
            box-sizing: border-box;
            margin-left: 15%;
            margin-right: 10%;
            @media screen and (max-width: 768px) {
                    margin: 0 20px !important;
                    overflow: hidden;
                }
            .info{
                text-indent: 2em;
                word-spacing: 2px;
            }
            .marginB22{
                margin-bottom: 22px;
            }
            .company_label{
                // width: 140px;
                // width: 353px;
                padding: 20px  30px;
                box-sizing: border-box;
                margin-bottom:40px ;
                // height: 128px;
                text-align: center;
                // opacity: 0.05;
                background: rgb(81, 80, 80,0.1);
                font-size: 46px;
                font-family: Adobe Heiti Std, Adobe Heiti Std-R;
                font-weight: normal;
                color: #2c2c2c;
                @media screen and (max-width: 1200px) {
                    height: auto;
                    font-size: 24px;
                }
                @media screen and (max-width: 768px) {
                    font-size:18px;
                    padding: 5px; 
                    margin-bottom:20px ;
                }
                // line-height: 12px;
                // letter-spacing: 3.67px;
            }
            .company_name{
                font-size:32px; 
                font-weight:600;
                @media screen and (max-width: 768px) {
                    font-size:22px; 
                }
            }
            .label{
                background: #A81F27;
                color: #fff;
                text-align: center;
            }
        }
        .right{
            position: relative;
            width: 100%;
            height: auto;
            max-height: 35vw;
            display: flex;
            overflow: hidden;
            justify-content: center;
            align-items: center;
            @media screen and (max-width: 768px) {
                width: 100vw;
                height: auto;
            }

            // height: 400px;
            // background: #bebebe;
            // img {
            //     overflow: revert !important;
            //     width: 100%;
            //     height: 100% !important;
            // }
            .swiper-container {
                // .swiper-pagination{
                //     width: 100%;
                // }
            }
            .swiper-slide img{
                width:100%;
                height:auto;
                object-fit: cover;
                min-height:100%;
                transition:1s linear 2s;
                transform:scale(1.4,1.4);
                @media screen and (max-width: 768px) {
                    margin: 0 auto;
                }
            }
            .swiper-slide-active img,.swiper-slide-duplicate-active img{
                transition:8s linear;
                transform:scale(1,1);
            }	
        }
            
    }
}

</style>